import { render, staticRenderFns } from "./TaxesAll.vue?vue&type=template&id=4877e10e&"
import script from "./TaxesAll.vue?vue&type=script&lang=js&"
export * from "./TaxesAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports